/**
 * Per-layer style persistence.
 *
 * Two style "types":
 *   • single    — uniform color / opacity / size for the whole layer
 *   • graduated — choropleth-style classification by attribute
 *
 * Schema (single):
 *   { type: 'single', applied: true,
 *     color: '#c8956d', opacity: 0.9,
 *     radius: 5,            // points only
 *     lineWidth: 1.5,       // lines + polygon outline
 *     fillOpacity: 0.25 }   // polygons only
 *
 * Schema (graduated):
 *   { type: 'graduated', applied: true,
 *     column, method, bins, ramp, breaks, min, max }
 */
const KEY = 'geohub_choropleth_v1';   // legacy key kept for migration

function readAll() {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}'); }
  catch { return {}; }
}
function writeAll(obj) {
  try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch {}
}

/** Migrate old-shape entries (no `type` field) to `graduated`. */
function migrate(entry) {
  if (!entry) return null;
  if (!entry.type && entry.applied && entry.breaks) {
    return { ...entry, type: 'graduated' };
  }
  return entry;
}

export function getStyle(layerId) {
  return migrate(readAll()[layerId]);
}

export function setStyle(layerId, style) {
  const all = readAll();
  all[layerId] = { ...style, applied: true };
  writeAll(all);
}

export function clearStyle(layerId) {
  const all = readAll();
  delete all[layerId];
  writeAll(all);
}
